import axios from 'axios'
import io from '@fedor/io'
import MC from '@/module/MC'
import { Message } from 'element'
// import store from '@/conf/home/store'

const reSlashPrefix = /^\/+/

const resolveURL = (url) => {
  if (url.indexOf('http') !== -1) {
    return url
  }
  if (url.charAt(0) !== '/') {
    return `${global.apiPrefix}/${url.replace(reSlashPrefix, '')}`
  }

  return url
}

/**
 * Resolve backend api url
 */
export { resolveURL }

const serverAlias = {
  merchant: 'merchant', // 商户平台的服务名
  merchandise: 'merchandise', // 商品中台服务
  merManager: 'mer-manager', // 海典健康微商城服务名 merGoods
  merPromote: 'promote', // 促销活动服务名
  dscloud: 'dscloud', // 电商云服务名
  mask: 'mask',
  customer: 'customer',
  live: 'hydee-live-service', // 直播服务
  analysis: 'ydjia-report', // 数据中心报表
  syncerp: 'syncerp', // erp数据同步
  operate: 'operate'
}

export { serverAlias }

const ioUploadImg = (payload, config) => {
  return new Promise((resolve, reject) => {
    axios.post(`${global.apiPrefix}/${serverAlias.merManager}/1.0/file/_upload`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': MC.getAuth()
      },
      ...config
    }).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}

export { ioUploadImg }

export const apiVersion = '1.0'
/**
 * Set io default instance resolveUrl globally
 */
io.config.resolveURL = resolveURL

// io.config.emulateJSON = false
const _propRequest = io.request

// Add a local request interceptor
io.request = spec => {
  return _propRequest.call(io, spec)
}

export const logOut = () => {
  MC.cleanCookie()
  window.location.href = `/app-login`
}

// Global response interceptor registion
io.interceptors.response.use(
  response => {
    console.log('app index 响应拦截：', response)
    // 静止30分钟失效重新登录
    if (response && response.data && response.data.code === 100200300) {
      Message({
        message: '登录失效，请重新登录',
        type: 'error',
        duration: 2000
      })
      setTimeout(() => {
        logOut()
      }, 1000)
      return
    }
    return response
  },
  error => {
    const { response } = JSON.parse(JSON.stringify(error))
    if (response.status === 403 || response.data.code === 40301) {
      Message({
        message: '登录失效，请重新登录',
        type: 'error',
        duration: 2000
      })
      setTimeout(() => {
        logOut()
      }, 1000)
      return
    }
    if (response.data.status === 404) {
      // location.toLogin()
      return
    }
    // if (response.data.code === 40301) {
    //   logOut()
    //   return
    // }
    // Do something with response error
    return Promise.reject(error)
  }
)

// Global request interceptor registion
io.interceptors.request.use(
  config => {
    let { method } = config
    if (method === 'get') {
      config.params = Object.assign({}, config.params, {
        _t: Math.random()
      })
    }
    if ((method === 'post' || method === 'put') && config.merCode) {
      config.data = { ...config.data, merCode: MC.config.userInfo.merCode }
    }
    config.headers.Authorization = MC.getAuth()
    if (config.data && config.data._api === 'dscloud') {
      config.headers['merCode'] = MC.config.userInfo.merCode
    }
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

export default io



// WEBPACK FOOTER //
// ./src/js/module/io/index.js